import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { colors } from "./theme.js";
/**
 * Shared modal overlay + centred dialog. Single source of truth for the
 * app's dialogs (replaces per-component overlay/backdrop/radius copies).
 *
 * - Drag-aware backdrop close: only closes when both mousedown AND mouseup
 *   land on the backdrop, so a text-selection drag that ends on the backdrop
 *   never discards a half-filled form.
 * - Escape closes.
 */
export function Modal({ onClose, title, children, width = 460, }) {
    const downOnBackdrop = useRef(false);
    useEffect(() => {
        const onKey = (e) => {
            if (e.key === "Escape")
                onClose();
        };
        document.addEventListener("keydown", onKey);
        return () => document.removeEventListener("keydown", onKey);
    }, [onClose]);
    return (_jsx("div", { onMouseDown: (e) => {
            downOnBackdrop.current = e.target === e.currentTarget;
        }, onMouseUp: (e) => {
            if (downOnBackdrop.current && e.target === e.currentTarget)
                onClose();
            downOnBackdrop.current = false;
        }, style: {
            position: "fixed",
            inset: 0,
            background: "rgba(15,23,42,0.45)",
            zIndex: 100,
            display: "grid",
            placeItems: "center",
            padding: 16,
        }, children: _jsxs("div", { role: "dialog", "aria-modal": "true", style: {
                width: `min(94vw, ${width}px)`,
                maxHeight: "88vh",
                overflowY: "auto",
                background: colors.surface,
                border: `1px solid ${colors.border}`,
                borderRadius: 12,
                boxShadow: colors.shadowLg,
                padding: 20,
            }, children: [title && (_jsx("h2", { style: { margin: "0 0 12px 0", fontSize: "1.1rem", color: colors.text }, children: title })), children] }) }));
}
